// extracted by mini-css-extract-plugin
export default {"form":"SGvjC1u-hNbxSkuHshwMXA==","buttonsRoot":"WCepV0eFISlUvNlnBWupIg=="};